import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { ProductReviewPage } from "@/modules/product";

export const Route = createFileRoute("/products/list/$slug/review")({
  component: () => (
    <>
      <DocumentTitle
        title="Product Review"
        description="Review product submission details before publishing."
      />
      <ProductReviewPage />
    </>
  )
});
